import Footer from "./Footer";
import Header from "./Header";

function Layout({ children }) {
    return (
        <div className="w-full h-screen">
            <Header />
            {children}
            <Footer />
        </div>
    )
}
export default Layout;